import React, { useMemo } from "react";
import { useAppSelector } from "../../../store/index.ts";
import ShowContainer from "../../mui/ShowContainer.jsx";
import JackpotContent from "./JackpotContent.jsx";

export default function Jackpot() {
  const jackpot = useAppSelector((state) => state.promotions.jackpots);
  const balance = useAppSelector((state) => state.user.balance);

  const jackpotEmpty = !(jackpot?.grand || jackpot?.major || jackpot?.mini);

  const currency = jackpot?.currency;
  const grand = jackpot?.grand || {};
  const major = jackpot?.major || {};
  const mini = jackpot?.mini || {};
  const decimal = useMemo(() => balance[currency]?.info?.decimal, [balance, currency]);
  const totalJackpotBalanceAmount =
    (grand?.amount || 0) + (major?.amount || 0) + (mini?.amount || 0);
  const totalJackpotBalance = totalJackpotBalanceAmount.toFixed(decimal);

  return (
    <ShowContainer condition={!jackpotEmpty && +totalJackpotBalance}>
      <JackpotContent
        currency={currency}
        decimal={decimal}
        grand={grand}
        jackpot={jackpot}
        major={major}
        mini={mini}
        totalJackpotBalance={totalJackpotBalance}
      />
    </ShowContainer>
  );
}
